<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>地图组件技能库</h2>
      <p>展示高德地图API的个性化用法</p>
    </div>

    <el-row :gutter="20">
      <el-col :span="24">
        <CodeCard 
          title="轨迹回放" 
          description="高德地图轨迹回放功能，支持播放、暂停、继续、停止和速度控制"
          :codeContent="trackMapCode">
          <TrackMap />
        </CodeCard>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import TrackMap from '@/components/map/TrackMap.vue'

export default {
  name: 'PcMap',
  components: {
    CodeCard,
    TrackMap
  },
  data() {
    return {
      trackMapCode: `<template>
  <div class="map-container">
    <div id="container"></div>
    <div class="control-panel">
      <el-button-group>
        <el-button type="primary" @click="startAnimation">开始回放</el-button>
        <el-button type="warning" @click="pauseAnimation">暂停</el-button>
        <el-button type="success" @click="resumeAnimation">继续</el-button>
        <el-button type="danger" @click="stopAnimation">停止/重置</el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  data() {
    return {
      map: null,
      marker: null,
      path: [],
      speed: 1000
    }
  },
  mounted() {
    AMapLoader.load({
      key: "YOUR_KEY",
      version: '2.0',
      plugins: ['AMap.MoveAnimation']
    }).then((AMap) => {
      this.map = new AMap.Map('container', {
        zoom: 15,
        center: [116.397428, 39.90923]
      });
      // 初始化轨迹...
    });
  }
}
<\/script>`,
    }
  }
}
</script>

<style scoped>
/* 全局样式已由 global.scss 提供 */
</style>
